import { safeDefine } from '@breuni-ui/safe-define';
import { CarouselNavigationNext } from '@breuni-ui/carousel';

export default class EntsNavigationNext extends CarouselNavigationNext {}
safeDefine('ents-carousel-navi-next', EntsNavigationNext);
